import ev from "../util/enumValue";

enum TickerSource {
    CUSTOM_TEXT = ev('CUSTOM_TEXT', 1),
    NOS_NEWS = ev('NOS_NEWS', 2),
}

export default TickerSource;
